import { Action } from 'redux';

import { SetOwner, SetOwnerSucceeded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IUserInfo } from '../../userManagement/users/models/IUserInfo';
import { IContentInfo } from '../models/IContentInfo';

export interface SetOwnerAction extends Action {
  items: IContentInfo[];
}

export function setOwner(items: IContentInfo[]): SetOwnerAction {
  return {
    type: SetOwner,
    items
  };
}

export const isSetOwnerAction = isActionFactory<SetOwnerAction>(SetOwner);

export interface SetOwnerSucceededAction extends Action {
  items: IContentInfo[];
  owner: IUserInfo;
}

export function setOwnerSucceeded(items: IContentInfo[], owner: IUserInfo): SetOwnerSucceededAction {
  return {
    type: SetOwnerSucceeded,
    items,
    owner
  };
}

export const isSetOwnerSucceededAction = isActionFactory<SetOwnerSucceededAction>(SetOwnerSucceeded);
